import {
  SET_SELECTED_DATE,
  SET_SELECTED_RESERVATION_IDS,
  SET_SELECTED_ROOM_ID,
  SET_SELECTED_RESERVATION_ID,
  FETCH_ROOMS_SUCCESS,
  CREATE_ROOM,
  UPDATE_ROOM,
  UPLOAD_ROOM_PICTURE,
  FETCH_RESERVATIONS_MONTH,
  CREATE_RESERVATION,
  UPDATE_RESERVATION,
  FETCH_RESERVATION_DETAILS,
  DELETE_SINGLE_RESERVATION,
  REMOVE_RESERVATION_DATE,
} from "./types";

import {
  getRooms,
  roomCreate,
  roomUpdate,
  roomPictureUpload,
  getReservationsMonth,
  reservationCreate,
  reservationUpdate,
  getReservationDetails,
  reservationDeleteSingle,
  reservationRemoveDate,
} from "../api";
import { dataFailure, dataSuccess } from "actions/general";

export const setSelectedReservationIds = (values) => {
  return {
    type: SET_SELECTED_RESERVATION_IDS,
    payload: values,
  };
};

export const setSelectedReservationDate = (values) => {
  return {
    type: SET_SELECTED_DATE,
    payload: values,
  };
};

export const setSelectedRoomId = (values) => {
  return {
    type: SET_SELECTED_ROOM_ID,
    payload: values,
  };
};

export const setSelectedReservationId = (values) => {
  return {
    type: SET_SELECTED_RESERVATION_ID,
    payload: values,
  };
};

const fetchRoomsSuccess = (values) => {
  return {
    type: FETCH_ROOMS_SUCCESS,
    payload: values,
  };
};

export const fetchRooms = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(getRooms(values));
      await dispatch(fetchRoomsSuccess(JSONData));
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const createRoomData = (values) => {
  return {
    type: CREATE_ROOM,
    payload: values,
  };
};

export const createRoom = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(roomCreate(values));
      await dispatch(createRoomData(JSONData));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const updateRoomData = (values) => {
  return {
    type: UPDATE_ROOM,
    payload: values,
  };
};

export const updateRoom = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(roomUpdate(values));
      await dispatch(updateRoomData(JSONData));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const uploadRoomPictureData = (values) => {
  return {
    type: UPLOAD_ROOM_PICTURE,
    payload: values,
  };
};

export const uploadRoomPicture = (values) => {
  return async (dispatch) => {
    try {
      const fileName = await dispatch(roomPictureUpload(values));
      await dispatch(uploadRoomPictureData(fileName));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const fetchReservationsMonthSuccess = (values) => {
  return {
    type: FETCH_RESERVATIONS_MONTH,
    payload: values,
  };
};

export const fetchReservationsMonth = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(getReservationsMonth(values));
      await dispatch(fetchReservationsMonthSuccess(JSONData));
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const createReservationData = (values) => {
  return {
    type: CREATE_RESERVATION,
    payload: values,
  };
};

export const createReservation = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(reservationCreate(values));
      await dispatch(createReservationData(JSONData));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const updateReservationData = (values) => {
  return {
    type: UPDATE_RESERVATION,
    payload: values,
  };
};

export const updateReservation = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(reservationUpdate(values));
      await dispatch(updateReservationData(JSONData));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const fetchReservationDetailsSuccess = (values) => {
  return {
    type: FETCH_RESERVATION_DETAILS,
    payload: values,
  };
};

export const fetchReservationDetails = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(getReservationDetails(values));
      await dispatch(fetchReservationDetailsSuccess(JSONData));
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const deleteSingleReservationData = (values) => {
  return {
    type: DELETE_SINGLE_RESERVATION,
    payload: values
  };
}

export const deleteSingleReservation = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(reservationDeleteSingle(values));
      await dispatch(deleteSingleReservationData(values));
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  }
}

const removeReservationDateData = (values) => {
  return {
    type: REMOVE_RESERVATION_DATE,
    payload: values
  };
}

export const removeReservationDate = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(reservationRemoveDate(values));
      await dispatch(removeReservationDateData(JSONData));
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  }
}
